import { render, staticRenderFns } from "./b13.vue?vue&type=template&id=0c6a58e2&scoped=true"
import script from "./b13.vue?vue&type=script&lang=js"
export * from "./b13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a58e2",
  null
  
)

export default component.exports